import getDefaultHeader from '@/utils/singUtil/getDefaultHeader';
import BhStatCommon from 'eco-design-micro/EcoStat/BhStatCommon';
import { useRouter } from 'next/router';

export default function BhStatCommonA({ systemTimestamp, textIdA1 }: { systemTimestamp: number; textIdA1?: string }) {
    const { locale = 'us' } = useRouter();
    const localeItem = getDefaultHeader(locale) || {};
    if (locale === 'cn') {
        return null;
    }
    return (
        <>
            <BhStatCommon systemTimestamp={systemTimestamp} project="ecoflow" appId={localeItem['x-appid']} textIdA1={textIdA1} locale={locale} />
        </>
    );
}
